<template>
  <div class="user-info page">
    <SaveCompleted v-if="this.completed"/>
    <div v-else class="container">
      <v-form ref="form">
        <CommonForm ref="refCommonForm" :userData="userData" />

        <div style="display: flex; justify-content: center;">
          <v-btn
            class="change-pwd-btn mb-6"
            color="secondary" x-regular
            depressed
            rounded
            @click="goChangePwdPage"
          >
            비밀번호 변경
          </v-btn>
        </div>

        <div style="display: flex; justify-content: center;">
          <a href="#" class="grey--text text-decoration-underline mb-4" @click="clickWithdraw">
            탈퇴하기
          </a>
        </div>
        <div class="bottom-btn">
          <v-btn
            color="primary"
            class="btn-text-white"
            x-large
            depressed
            block
            @click="clickSave"
          >
            개인 정보 변경
          </v-btn>
        </div>
      </v-form>
    </div>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
    <Footer />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CommonForm from "../signUp/comp/CommonForm.vue";
import SaveCompleted from "./comp/SaveCompleted.vue"
import ConfirmDialog from "@/_zplabZPT/commonComp/dialog/ConfirmDialog.vue";
import Footer from "../commonComp/Footer.vue";

const modelService = require("@/utils/dataModel.js");

export default {
  components: {
    CommonForm,
    SaveCompleted,
    ConfirmDialog,
    Footer
  },
  data() {
    return {
      userData: modelService.userModel(),
      completed: false,
      action: '',
    };
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  mounted() {
    const $h = this.$helper;
    this.getMeInfo().then(() => {
      this.userData = this.meInfo;
    });
  },
  methods: {
    goChangePwdPage(){
        window.location.href = "/changePassword";
    },
    clickSave() {
      // 필수체크
      const $h = this.$helper;
      const RF = this.$refs;
      this.action = 'save';
      if (!RF.form.validate()) {
        return;
      }

      this.$refs.refConfirmDialog.open("회원정보를 수정하시겠습니까?");
    },

    clickWithdraw() {
      this.action = 'withdraw';
      this.$refs.refConfirmDialog.open("탈퇴하시겠습니까?");
    },
    clickPopupConfirm() {
      const $h = this.$helper;
      const DT = this.userData;

      // 정보 변경
      if(this.action == 'save'){
        DT.endpoint = "meUpdate";
        DT.endpointUser = "user";
        this.saveDataQuery(DT).then((res) => {
          if (res === undefined) return;

          this.completed = true
          window.scrollTo({ top: 0, behavior: 'smooth' });

        });
      }
      // 회원 탈퇴
      if(this.action == 'withdraw'){
        DT.endpoint = "withdrawal";
        DT.endpointUser = "user";
        this.saveDataQuery(DT).then((res) => {
          if (res === undefined) return;

          this.$helper.showTostMessage("","회원 탈퇴가 정상적으로 처리되었습니다.","success");
          this.signOut();
          this.$router.push("/login");
        });
      }
    },
    clickPopupOk() {},
    ...mapActions(["getMeInfo", "saveDataQuery", "signOut"]),
  },
};
</script>
<style lang="scss">
@media (min-width: 769px) {
  div.user-info {
    .bottom-btn {
      padding: 20px calc((100% - 600px) / 2);
      .v-btn__content {
        color:#fff;
        font-weight: 800;
      }
    }
  }
}
.user-info {
  position: relative;
  padding-bottom: 150px;

  .page-inner {
    padding: 20px;
    height: calc(100svh - 220px);
    position: relative;

    .v-btn:not(.v-btn--round).v-size--x-large {
      margin-top: 30px;
    }
  }
}
</style>
